import { TableCell } from '@mui/material';
import ValidatedTextField from './ValidatedTextField';
import { TextFieldElementProps } from 'react-hook-form-mui';

interface IProps extends TextFieldElementProps {
    value: string | number | null;
    readOnly: boolean;
    endAdornment?: string;
    type?: string;
}

export default function EditableTableCell({ name, value, readOnly, onChange, type, endAdornment }: IProps) {
    return (
        <TableCell>
            {readOnly ? endAdornment ? value ? value + " " + endAdornment : value : value : (
                <ValidatedTextField
                    name={name}
                    value={value}
                    onChange={onChange}
                    type={type}
                    endAdornment={endAdornment}
                />
            )}
        </TableCell>
    );
};
